import React from 'react';
function DrawerHeader({ onClose, children }) { return /*#__PURE__*/ React.createElement("header", { className: "drawer__header" }, /*#__PURE__*/ React.createElement("h2", { className: "drawer__title" }, children), /*#__PURE__*/ React.createElement("button", { className: "drawer__overlay__close", onClick: onClose })); }
export default DrawerHeader;
